import { render, staticRenderFns } from "./attorney-review.vue?vue&type=template&id=e739a30e"
import script from "./attorney-review.vue?vue&type=script&lang=js"
export * from "./attorney-review.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports